// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__SNTGL","bigColWidth":"Table_bigColWidth__H_9QX","biggerColWidth":"Table_biggerColWidth__dSPpI","row":"Table_row__3WrZK","col":"Table_col__21huW"};